// extracted by mini-css-extract-plugin
export default {"top":"style_top__VXpws","profile":"style_profile__cJNd-","image":"style_image__+M0Wr","name":"style_name__yZXdI","Shouts":"style_Shouts__DdenE","options":"style_options__PmLis"};